module.exports = __webpack_public_path__ + "static/media/home-product-landing-image-01.3d165e5a.jpg";